import React, { useContext } from "react";
import styles from "./productsHeroBanner.module.css";

import { LanguageContext } from "../../context/LanguageContext";

function HeroBanner() {
  const { data } = useContext(LanguageContext);
  const heading = data.ourProductsHeroBanner[0].title;

  return (
    <div className={styles.heroProductBanner}>
      {data.ourProductsHeroBanner.map((item, i) => (
        <div key={i} className={styles.heroBanner}>
          <div className={styles.titleGroup}>
            <h1 className={styles.title}>{heading}</h1>
          </div>
          <img src={`${item.img}`} alt="fruits" />
        </div>
      ))}
    </div>
  );
}

export default HeroBanner;
